export default "__VITE_ASSET__DdnayIvQ__"